import { type CSSProperties, globalStyle, style } from "@vanilla-extract/css";
import { recipe } from "@vanilla-extract/recipes";
import { rem } from "@huub-web/utils/css/rem";
import { zIndexes } from "@huub-web/ui/theme/zIndex";
import { responsive } from "@huub-web/ui/utils/responsive";

import { theme } from "@huub-web/ui/theme/css/theme.css";
import { typographyDefinition } from "@huub-web/ui/theme/typography";

export const mapContainerStyle = style({
  width: "100%",
  height: "100%",
  overflow: "hidden",
  flexGrow: 1,
});

globalStyle(".mapboxgl-ctrl-logo", {
  display: "none !important",
});

globalStyle(".mapbox-improve-map", {
  display: "none !important",
});

export const mapWrapperStyle = recipe({
  base: {
    position: "relative",
    width: "100%",
    height: "100%",
    display: "flex",
  },
});

export const controlsContainerStyle = style({
  position: "absolute",
  inset: 0,
  zIndex: zIndexes.mapControls,
  padding: theme.spacings.m,
  pointerEvents: "none",
  display: "grid",
  gridTemplateColumns: "auto 1fr auto",
  gridTemplateRows: "auto 1fr auto",
  gap: theme.spacings.s,
});

export const leadingSlotStyle = style({
  gridColumn: 1,
  gridRow: 1,
  justifySelf: "start",
  alignSelf: "start",
  pointerEvents: "auto",
});

export const closeSlotStyle = style({
  gridColumn: 3,
  gridRow: 1,
  justifySelf: "end",
  alignSelf: "start",
  pointerEvents: "auto",
});

/**
 * Map tools (layer select + zoom). Bottom-left on mobile, top-right beside the
 * close button on larger screens.
 */
export const mapToolsStyle = style({
  display: "flex",
  flexDirection: "row",
  alignItems: "flex-start",
  gap: theme.spacings.s,
  pointerEvents: "auto",
  gridColumn: 1,
  gridRow: 3,
  justifySelf: "start",
  alignSelf: "end",
  ...responsive({
    s: {
      gridColumn: 2,
      gridRow: 1,
      justifySelf: "end",
      alignSelf: "start",
    },
  }),
});

export const zoomControlsStyle = style({
  pointerEvents: "auto",
  flexGrow: 0,
  flexShrink: 0,
});

export const zoomButtonTextStyle = style({
  lineHeight: 1,
});

export const groupStyle = style({
  borderRadius: theme.borderRadiuses.xs2,
});

export const layerSelectStyle = style({
  height: `${rem(36)} !important`,
  flexGrow: 1,
  pointerEvents: "auto",
});

globalStyle(".mapbox-view[data-type='animated'] .mapboxgl-marker", {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  pointerEvents: "none !important" as any,
});

/**
 * Mapbox popup styles to match UI Tooltip component
 */
globalStyle(".mapboxgl-popup-content", {
  ...(typographyDefinition.bodyM as CSSProperties),
  backgroundColor: `${theme.colors.secondary} !important`,
  color: `${theme.colors.onSecondary} !important`,
  borderRadius: `${theme.borderRadiuses.s} !important`,
  padding: `${theme.spacings.s} !important`,
  maxWidth: `${rem(280)} !important`,
  boxShadow: "none !important",
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  pointerEvents: "none !important" as any,
});

globalStyle(".mapboxgl-popup-tip", {
  display: "none",
});

globalStyle(".mapboxgl-popup-content h3", {
  ...(typographyDefinition.displayS as CSSProperties),
  fontWeight: "bold",
  lineHeight: 1,
});

globalStyle(".mapboxgl-popup-content i", {
  ...(typographyDefinition.surfaceSubtitle as CSSProperties),
  fontStyle: "normal",
  opacity: 0.5,
  lineHeight: 1,
});

globalStyle(".mapboxgl-popup-content strong", {
  lineHeight: 1,
});
